import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { QUESTIONS_ROUTES } from '../../pages/Questions/data';
import { getDataRoomRoute } from 'utils';

const RedirectToNewQuestionsRouter: React.FC = () => {
  const {
    dataRoom: { _id },
    doesUserHaveAccessToQa,
  } = useContext(DataRoomContext);

  const { pathname } = useLocation();

  const isOnQa = pathname?.includes(QUESTIONS_ROUTES.Q_AND_A);

  const to = getDataRoomRoute(
    _id,
    isOnQa && doesUserHaveAccessToQa
      ? 'questions/questions-and-answers'
      : 'questions/frequently-asked-questions',
  );

  return <Navigate replace to={to} />;
};

export default RedirectToNewQuestionsRouter;
